import useStrings from "../../localization/useStrings"
import native from "../../native/native"

interface Props {
  containerClass: string
  buttonClass: string
}

const TermsButtons = ({ containerClass, buttonClass }: Props) => {
  const strings = useStrings()

  return (
    <div className={`${containerClass}`}>
      <button
        className={buttonClass}
        onClick={() => native.postNativeEvent("privacy")}
      >
        {strings.privacy}
      </button>
      <button
        className={buttonClass}
        onClick={() => native.postNativeEvent("already_purchased")}
      >
        {strings.alreadyPurchased}
      </button>
      <button
        className={buttonClass}
        onClick={() => native.postNativeEvent("terms")}
      >
        {strings.termsButton}
      </button>
    </div>
  )
}

export default TermsButtons
